export default __webpack_public_path__ + "static/media/skins-tablet-grid.1aa4ef63.png";